/*
Copyright (c) 2012-2024 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { jsx } from "@emotion/core"
import { FC } from "react"
import { StarFilled } from "@duxton-web/icons"
import classNames from "classnames"
import { fontStyles } from "./NumberStarRating.styles"
import styles from "./styles.modules.css"

export interface NumberStarRatingProps {
  rating: number
  className?: string
  ratingThreshold?: number
  maxRating?: number
}

export const ratingTresholdValue = 3.5

export const NumberStarRating: FC<NumberStarRatingProps> = props => {
  const {
    rating,
    className = "",
    ratingThreshold = ratingTresholdValue,
    maxRating = 5,
  } = props
  let ratingFiltered: number = rating

  ratingFiltered = ratingFiltered > maxRating ? maxRating : ratingFiltered
  ratingFiltered = ratingFiltered < 0 ? 0 : ratingFiltered
  return (
    <span css={fontStyles}>
      <span
        className={classNames(
          className,
          rating > ratingThreshold ? styles.goodRating : styles.badRating,
        )}
      >
        {ratingFiltered}
      </span>
      <StarFilled className={styles.starStyling} />
    </span>
  )
}
